import { Table, TableCheckbox, TableService } from 'primeng/table';
import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { CheckboxChangeEvent } from 'primeng/checkbox';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  // tslint:disable-next-line
  selector: 'miq-tableCheckbox',
  template: `
    <label class="container">
      <input
        type="checkbox"
        [checked]="selectedValue"
        (click)="onClick($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
      />
      <span class="checkmark"></span>
    </label>
  `,
  standalone: true,
})
export class MiqTableCheckboxComponent extends TableCheckbox {
  // `value` is inherited from PrimeNG's TableCheckbox as a plain field and is
  // read inside super.onClick → dt.toggleRowWithCheckbox(event, this.value).
  // If we redeclare it as `value = input<any>()`, the subclass field shadows
  // the inherited one and `this.value` becomes the signal *getter function*,
  // so PrimeNG pushes the function reference into the selection array — every
  // checkbox-driven selection ends up as `[ƒ]` and downstream consumers can
  // never match it back to row data. Use an aliased signal input and mirror
  // it onto the inherited plain field.
  readonly valueInput = input<any>(undefined, { alias: 'value' });
  selection = input<any>();
  allMatches = input(false);
  selectedValue: boolean = false;
  private isUserClick: boolean = false;
  constructor(dataTable: Table, tableService: TableService) {
    super(dataTable, tableService);
    effect(() => {
      // Mirror the signal-input value onto the inherited plain field so
      // super.onClick / toggleRowWithCheckbox see actual row data.
      this.value = this.valueInput();
      this.selection();
      if (this.isUserClick) return;
      this.selectedValue = false;
      if (this.selection()?.length) {
        for (let eachSelection of this.selection()) {
          const isMatch = this.isSelectionMatch(eachSelection);
          if (isMatch) {
            this.selectedValue = true;
            break;
          }
        }
      }
    });
  }
  onClick(event: CheckboxChangeEvent) {
    event.originalEvent?.stopPropagation();
    event.originalEvent?.preventDefault();
    this.isUserClick = true;
    this.selectedValue = !this.selectedValue;
    super.onClick(event);
    // Reset flag synchronously after the click is processed
    this.isUserClick = false;
  }
  // in some places we are getting entity as object, in some places we are getting object with id,
  //in some places we are not getting entity object or id
  isSelectionMatch(eachSelection) {
    // Guard against null/undefined ids to prevent false matches across unrelated rows
    const entityIdMatch =
      eachSelection.entity?.id != null &&
      this.value?.entity?.id != null &&
      eachSelection.entity.id === this.value.entity.id;

    return entityIdMatch ||
      (eachSelection.id && eachSelection.id === this.value?.id) ||
      JSON.stringify(eachSelection) === JSON.stringify(this.value);
  }
  onFocus() {
    // intentional to override default behavior from parent
  }
  onBlur() {
    // intentional to override default behavior from parent
  }
}
